var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useEffect, useState } from 'react';
import { languageKeyToLanguageCode } from '../../utils/common';
var TRANSLATION_URL_PREFIX = 'https://cta-tcg-asset-bundles-live.s3.eu-west-3.amazonaws.com/game/reachables/text';
var TRANSLATION_URL_SUFFIX = 'localization/localization';
var TRANSLATION_SECTIONS = ['shop', 'entity', 'card-info'];
export function useExternalTranslationsContext() {
    var language = useI18n().i18n.language;
    var _a = useState(undefined), translations = _a[0], setTranslations = _a[1];
    var _b = useState(false), initialized = _b[0], setInitialized = _b[1];
    useEffect(function () {
        function getFiles() {
            return __awaiter(this, void 0, void 0, function () {
                var resultedTranslations, languageCode, files, _i, files_1, file;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!initialized)
                                return [2 /*return*/];
                            setTranslations(undefined);
                            resultedTranslations = {};
                            languageCode = languageKeyToLanguageCode(language);
                            return [4 /*yield*/, Promise.all(TRANSLATION_SECTIONS.map(function (section) { return __awaiter(_this, void 0, void 0, function () {
                                    var formatedLanguageCode, response;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                formatedLanguageCode = languageCode.toLowerCase().replaceAll('_', '-');
                                                return [4 /*yield*/, fetch("".concat(TRANSLATION_URL_PREFIX, "/").concat(formatedLanguageCode, "/").concat(TRANSLATION_URL_SUFFIX, "-").concat(section, "-").concat(formatedLanguageCode, ".json"))];
                                            case 1:
                                                response = _a.sent();
                                                return [4 /*yield*/, response.json()];
                                            case 2: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); }))];
                        case 1:
                            files = _a.sent();
                            for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                                file = files_1[_i];
                                resultedTranslations = __assign(__assign({}, resultedTranslations), file);
                            }
                            setTranslations(resultedTranslations);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getFiles();
    }, [language, initialized]);
    return { externalTranslations: translations, initialize: function () { return setInitialized(true); } };
}
